import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import "@/i18n/index";
import AccessibilityWidget from "@/components/feature/AccessibilityWidget";
import CookieBanner from "@/components/feature/CookieBanner";
import SocialFloating from "@/components/feature/SocialFloating";

declare const __BASE_PATH__: string;

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <AccessibilityWidget />
      <CookieBanner />
      <SocialFloating />
    </BrowserRouter>
  );
}

export default App;
